export const SessionQueryKey = {
    me: () => ['me'],
}
